import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { ProgressLine } from '@ucheba/ui/components/ProgressLine/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { EActivityInfoPart, EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { useRouter } from 'next/router'
import { getSingleQuery } from '@ucheba/utils/helpers/router'
import { ISyllabus } from '../types'
import { useSyllabus } from '../bll/useSyllabus'
import { useUserActivity } from '../../../../../../../../../utils/hooks/useUserActivity'
import { useGetInstitutionsId } from '../../../bll/useGetInstitutionsId'

const Syllabus: FC<ISyllabus> = (props) => {
  const { list } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const { newList } = useSyllabus(list)
  const { query } = useRouter()
  const id = query?.id

  const { setUserActivity } = useUserActivity()

  const institutionId = useGetInstitutionsId()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId,
      data: { infoPart: EActivityInfoPart.disciplineHours },
      programId: getSingleQuery(id) as undefined | number,
    })
  }

  return (
    <div>
      <Heading h3='Учебный план' spacing='small' />

      <LimitedList
        id='syllabus'
        items={newList}
        isAuth={isAuth}
        buttonText='Показать все предметы'
        limit={4}
        showMore
        onShowAll={handleShowAllClick}
      >
        {({ limitedItems }) => {
          return (
            <div>
              {limitedItems.map((item, key) => {
                return (
                  <div key={key}>
                    <Grid spacing='xxsmall' justifyContent='space-between' nowrap>
                      <GridCol width='auto' shrink='1'>
                        <Text fontWeight='bold'>
                          {item.optional
                            ? `${item.discipline.name} (по выбору)`
                            : item.discipline.name}
                        </Text>
                      </GridCol>

                      <GridCol width='auto'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            height: '100%',
                          }}
                        >
                          <Text fontWeight='bold' color='blue'>
                            {item.hours ? `${item.hours} ак. ч.` : ''}
                          </Text>
                        </div>
                      </GridCol>
                    </Grid>

                    <Spacing spacing='xxsmall' />

                    <ProgressLine
                      color='blue'
                      currentMaxValue={item.hours ? item.percent : 100}
                    />

                    <Spacing spacing='large' />
                  </div>
                )
              })}
            </div>
          )
        }}
      </LimitedList>
    </div>
  )
}

export default Syllabus
